module.exports = "/_next/static/images/num-7-6359f5e2.png";